import React from "react";
import "../../../scss/progressbar.scss";
import { MDBIcon } from "mdb-react-ui-kit";

const renderStep = (step, condition, label, date) => {
  const showDate = step >= condition && date;
  return (
    <li className={`step ${step >= condition ? "current" : ""}`}>
      {step >= condition && <MDBIcon fas className="mx-1" icon="check" />}
      {label}
      {showDate && ` (${date})`}
    </li>
  );
};

const ArrowProgressBar = ({ step, billType, dates }) => {
  const steps =
    billType === "H"
      ? [
          { condition: 1, label: "Introduced", dateIndex: dates.length - 1 },
          {
            condition: 2,
            label: "Passed (H) Committee",
            dateIndex: dates.length - 2,
          },
          { condition: 3, label: "Passed House", dateIndex: dates.length - 3 },
          {
            condition: 4,
            label: "Passed (S) Committee",
            dateIndex: dates.length - 3,
          },
          { condition: 5, label: "Passed Senate", dateIndex: dates.length - 4 },
          { condition: 6, label: "To Governor", dateIndex: dates.length - 5 },
        ]
      : [
          { condition: 1, label: "Introduced", dateIndex: dates.length - 1 },
          {
            condition: 2,
            label: "Passed (S) Committee",
            dateIndex: dates.length - 2,
          },
          { condition: 3, label: "Passed Senate", dateIndex: dates.length - 3 },
          {
            condition: 4,
            label: "Passed (H) Committee",
            dateIndex: dates.length - 4,
          },
          { condition: 5, label: "Passed House", dateIndex: dates.length - 5 },
          { condition: 6, label: "To Governor", dateIndex: dates.length - 6 },
        ];

  return (
    <div className="arrow-steps-container mb-3">
      <ul className="arrow-steps list-unstyled d-flex">
        {steps.map(({ condition, label, dateIndex }, index) => (
          <React.Fragment key={index}>
            {renderStep(
              step,
              condition,
              label,
              dates[dateIndex] || "Unknown"
            )}
          </React.Fragment>
        ))}
      </ul>
    </div>
  );
};

export default ArrowProgressBar;
